export default __webpack_public_path__ + "static/media/ic_shib_40.1cee1bf8.svg";